import React, { createContext, createElement, Component } from 'react';

export const FormContext = createContext(null);

export function withForm(PassedComponent) {
  return class extends Component {
    render() {
      return createElement(FormContext.Consumer, {
        children: (form) =>
          createElement(PassedComponent, {
            form,
            ...this.props,
          }),
      });
    }
  };
}
